import React, { useState } from 'react';
import { Grid, InputLabel, MenuItem } from '@mui/material';
import { PrimaryOutlinedButton, PrimaryLightInput, PrimaryLightSelect } from '../../theme/index'
import '../../sass/styles.scss';
import FormControl from '@mui/material/FormControl';
import { useDispatch } from 'react-redux';
import { modalAction } from '../../redux/reducers/Modal';
import { editClientAction } from '../../redux/reducers/Edit';

const ClientsEdit = (props) => {

    const dispatch = useDispatch();
    const [id, setId] = useState(props.client.id);
    const [docType, setDocType] = useState(props.client.documentType);
    const [docNumber, setDocNumber] = useState(props.client.documentNumber);
    const [name, setName] = useState(props.client.name);
    const [lname, setLname] = useState(props.client.lastname);
    const [email, setEmail] = useState(props.client.email);
    const [status, setStatus] = useState(props.client.status);

    const editClient = () => {
        const clientEdited = new FormData();
        const dataNames = ["id","documentType", 'documentNumber', 'name', 'lastname', 'email', 'status'];

        clientEdited.append(dataNames[0], id);
        clientEdited.append(dataNames[1], docType);
        clientEdited.append(dataNames[2], docNumber);
        clientEdited.append(dataNames[3], name);
        clientEdited.append(dataNames[4], lname);
        clientEdited.append(dataNames[5], email);
        clientEdited.append(dataNames[6], status);
        clientEdited.append('METHOD', 'PUT');

        dispatch(editClientAction(clientEdited, dataNames, id));
        dispatch(modalAction());
    }

  return (
    <>
        <Grid item xs={ 10 }>
            <h5 style={{ margin: '0' }}>Cliente / editar</h5>
        </Grid>
        <Grid item xs={ 12 }>
            <Grid container sx={{ py: 6 }}>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Tipo de documento</InputLabel>
                        <PrimaryLightSelect 
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Tipo de documento"
                        value={ docType }
                        onChange={ e => setDocType(e.target.value) }
                        >
                            <MenuItem value='passport'>Pasaporte</MenuItem>
                            <MenuItem value="v">V-</MenuItem>
                            <MenuItem value="e">E-</MenuItem>
                            {/* <MenuItem value='identification'>Nº de identificación</MenuItem> */}
                        </PrimaryLightSelect>
                    </FormControl>
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Nº de documento"
                        fullWidth
                        value={ docNumber }
                        onChange={ e => setDocNumber(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Nombre"
                        fullWidth
                        value={ name }
                        onChange={ e => setName(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Apellido"
                        fullWidth
                        value={ lname }
                        onChange={ e => setLname(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="E-mail"
                        fullWidth
                        type='email'
                        value={ email }
                        onChange={ e => setEmail(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                        <PrimaryLightSelect 
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={ status }
                        onChange={ e => setStatus(e.target.value) }
                        >
                            <MenuItem value={true}>Activo</MenuItem>
                            <MenuItem value={false}>Inactivo</MenuItem>
                        </PrimaryLightSelect>
                    </FormControl>
                </Grid>
                <Grid item xs={ 12 } sx={{ mt: 5 }} textAlign='end' className='pr-2'>
                    <PrimaryOutlinedButton onClick={ () => editClient() }>Guardar</PrimaryOutlinedButton>
                </Grid>
            </Grid>
        </Grid>
    </>
  )
}

export default ClientsEdit